'use strict';
import Routes from '@expressive-analytics/vue-routes'
import {root} from "./components"
Routes.components['root'] = root

import r from "./routes.yml"
Routes.parseRoutes(r)

// load up theme components
import ThemeMainNav from './main-nav.vue'
import ThemeFooter from './footer.vue'

export {
  ThemeMainNav,
  ThemeFooter
}
